import { jsx as _jsx } from "react/jsx-runtime";
import { Neon } from '../neon';
export const ProjectDetailsPageTemplate = ({ documentTitle, title, tabs, children })=>/*#__PURE__*/ _jsx(Neon, {
        documentTitle: documentTitle,
        title: title,
        tabs: tabs,
        actions: {},
        content: children,
        $island: true
    });
